export default "__VITE_ASSET__Cqodbu1P__"